import initialState from 'initialState';
import { Reducer } from 'redux';

const productData: Reducer<ACachedData> = (state = initialState.productData) => state;
export default productData;
